module.exports = __webpack_public_path__ + "static/media/SILKSERIF-MEDIUM.4f88f545.woff2";